import React, { useState } from 'react';
import styled from 'styled-components';

import {
  getDownloadURL,
  ALL_MODULES,
  AttachmentPreviewer
} from '@nile/components';
import AttachmentHolder from '@nile/rmm/src/modules/common/components/sub-pages/attachment-holder';
import { AttachmentItemHolder } from '@nile/banyan/src/Components/Editors/RTEditor';

const AttachmentsContainer = styled(AttachmentItemHolder)`
  margin-right: 10px;
  padding: 0 1rem;
  &:hover {
    cursor: default;
  }
  .Polaris-Link {
    display: flex;
    align-items: center;
    padding: 1rem 0.2rem !important;
  }
`;

const AttachmentsList = ({
  attachmentsList,
  module = 'PROJECT_TEMPLATE_ATTACHMENT',
  template
}) => {
  const [showAttachmentPreview, setShowAttachmentPreview] = useState({
    show: false,
    index: 0
  });
  const [formatterAttachment, setFormatterAttachment] = useState([]);

  const getAttachmentURL = (item) => {
    const details = {
      fileName: item?.fileName
    };

    switch (module) {
      case ALL_MODULES.notificationTemplateAttachment:
        details.templateId = template?.id;
        details.type = template?.templateType;
        break;
      case 'PROJECT_TEMPLATE_ATTACHMENT':
        details.projectTemplateId = template?.id;
        break;
      default:
        break;
    }

    const url = getDownloadURL({ module, details });
    return url;
  };

  function formatAttachmentForPreview(attachments, cb) {
    const formatted = attachments.map((item) => {
      if (item)
        return {
          name: item.fileName,
          url: getAttachmentURL(item),
          type: item.fileName.substr(
            item.fileName.lastIndexOf('.') + 1,
            item.fileName.length
          )
        };
    });
    setFormatterAttachment(formatted);
    if (cb) cb();
  }

  function openAttachmentPreview(index, attachments) {
    if (attachments) {
      formatAttachmentForPreview(attachments, () => {
        setShowAttachmentPreview({
          ...showAttachmentPreview,
          show: true,
          index
        });
      });
    }
  }

  const closePreviwer = () => {
    setShowAttachmentPreview({
      ...showAttachmentPreview,
      show: false
    });
  };

  return (
    <div>
      <div className="fx">
        {attachmentsList?.map((item, index) => {
          return (
            <AttachmentsContainer>
              <AttachmentHolder
                onClick={() => openAttachmentPreview(index, attachmentsList)}
                fileName={item?.fileName || ''}
              />
            </AttachmentsContainer>
          );
        })}
      </div>
      {showAttachmentPreview.show && (
        <AttachmentPreviewer
          showPreviewer={showAttachmentPreview.show}
          closePreviwer={closePreviwer}
          list={formatterAttachment}
          selectedIndex={showAttachmentPreview.index}
        />
      )}
    </div>
  );
};

export default AttachmentsList;
